import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthRoutingModule } from './auth-routing.module';
import { MaterialModule } from '../../shared/material.module';

// fid-ui components (standalone)
import { ButtonComponent } from '@fid/fid-ui';
import { LoaderComponent } from '@fid/fid-ui';

import { AuthLayoutComponent } from './layout/auth-layout.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { ErrorAuthComponent } from './error/error-auth.component';

@NgModule({
  declarations: [
    AuthLayoutComponent,
    LoginComponent,
    LogoutComponent,
    UnauthorizedComponent,
    ErrorAuthComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AuthRoutingModule,
    MaterialModule,
    // fid-ui standalone components
    ButtonComponent,
    LoaderComponent,
  ],
})
export class AuthModule {}
